import PayrollCalculator from "./PayrollCalculator";
export default PayrollCalculator;